// extracted by mini-css-extract-plugin
export default {"floatMenu":"FloatMenu_floatMenu__cct49","modalOpen":"FloatMenu_modalOpen__gOGdj","modalClosed":"FloatMenu_modalClosed__M3yPD"};